/**
 *  CamapaignCardCompareDropdown script file
**/
import filters from '@/filters/customFormatters'
import campaignsUtils from '@/mixins/campaignsUtils'

export default {
  name: 'CamapaignCardCompareDropdown',
  mixins: [filters, campaignsUtils],
  components: {
    Tag: () => import('@/components/common/tag/Tag.vue')
  },
  props: {
    campaign: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: '',
      required: false
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    discard () {
      this.$emit('discard', this.campaign)
    }
  }
}
